import { Box, Flex, Icon, Text, Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { decode } from 'js-base64';
import { NotificationCard, useNotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import { WarningNotification } from '@/assets/icons/notification';
import { NotificationLink } from '../components/NotificationLink';

export const FlowPausedForCandidatesWrapper = ({
  notification = {},
  onClose = () => {},
}) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const { markAsRead } = useNotificationCard();

  return (
    <Flex pl="12px">
      <Icon as={WarningNotification} width="40px" height="40px" />
      <Box ml="12px">
        <Text mb="12px">
          Flow paused for
          <Text as="span" px="4px">
            {data?.count}
          </Text>
          candidates in
          <NotificationLink
            to={`/flows/${data?.outreach_id}`}
            label={data?.outreach_name}
            onClose={onClose}
            notification={notification}
            data-test-id="flow-link"
          />
          due to other errors
        </Text>
        <Flex alignItems="center" gap="12px" flexDir="row-reverse">
          <Link to={`/flows/${data?.outreach_id}/candidates?errors=others`}>
            <Button
              onClick={() => {
                onClose();
                markAsRead();
              }}
              data-test-id="action-errors-button"
            >
              Action on errors
            </Button>
          </Link>
          <NotificationTime notification={notification} />
        </Flex>
      </Box>
    </Flex>
  );
};

export const FlowPausedForCandidates = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <FlowPausedForCandidatesWrapper
        notification={notification}
        onClose={onClose}
      />
    </NotificationCard>
  );
};
